<template>
  <scout-form
    :is-modified="!!toeic || !!toefl || !!english"
    label="語学力"
  >
    <div class="boss-layout boss-layout-start boss-layout-wrap boss-layout-gap-large">
      <div>
        TOEIC:
        <input
          :value="toeic"
          class="boss-input"
          style="width: 6em;"
          type="number"
          data-test="toeic"
          max="990"
          min="0"
          @change="$emit('update:toeic', Number($event.target.value) || null)"
          @keypress="onlyNumberInRange($event, 990)"
        >点以上
      </div>
      <div>
        TOEFL:
        <input
          :value="toefl"
          class="boss-input"
          style="width: 6em;"
          type="number"
          data-test="toefl"
          max="677"
          min="0"
          @change="$emit('update:toefl', Number($event.target.value) || null)"
          @keypress="onlyNumberInRange($event, 677)"
        >点以上
      </div>
      <div>
        英語スキル:
        <select
          :value="english"
          class="boss-input-select"
          @change="$emit('update:english', Number($event.target.value) || null)"
        >
          <option
            value=""
          >
            指定なし
          </option>
          <option
            v-for="(option ,i) in languageSkillsMaster"
            :key="i"
            :value="option.id"
            :data-test="`english-${option.id}`"
          >
            {{ option.name }}
          </option>
        </select>
        <span>以上</span>
      </div>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import { mapGetters } from 'vuex'
import eventValidations from '@/lib/eventValidations'

export default {
  components: {
    ScoutForm
  },
  mixins: [eventValidations],
  props: {
    toeic: {
      default: null,
      type: Number
    },
    toefl: {
      default: null,
      type: Number
    },
    english: {
      default: null,
      type: Number
    }
  },
  computed: {
    ...mapGetters([
      'languageSkillsMaster'
    ])
  }
}
</script>
